import TabbedContent from './TabbedContent'

export default TabbedContent
